export const TABS = [
  {
    label: 'All',
    id: 1,
    key: 1,
    tooltip: 'No filter — shows all customers',
  },
  {
    label: 'New',
    id: 2,
    key: 2,
    tooltip: 'Created within the last 7 days',
  },
  {
    label: 'Active',
    id: 3,
    key: 3,
    tooltip: 'Placed a completed order in the last 30 days (and created more than 7 days ago)',
  },
  {
    label: 'Inactive',
    id: 4,
    key: 4,
    tooltip: 'Has never placed a completed order (and created more than 7 days ago)',
  },
  {
    label: 'Lost',
    id: 5,
    key: 5,
    tooltip: 'Last completed order was more than 30 days ago',
  },
];
